<template>
  <div class="countdown">
    <div class="days">{{ days }}</div>
    <div class="label">{{ label }}</div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState(['countdown', 'countdownLabel']),
    days() {
      if (!this.countdown) {
        return '';
      }
      return Math.floor(this.countdown / 1000 / 60 / 60 / 24);
    },
    label() {
      return this.countdownLabel;
    },
  },
};
</script>

<style scoped>
.days {
  text-align: center;
  font-weight: bold;
  font-size: 76pt;
}
.label {
  font-size: 20pt;
  text-align: center;
}
</style>
